import React, { useEffect, useRef, useState } from "react";
import Button from "../UI/Button";
import _axios from "../../httpService";
import { ReactTabulator } from "react-tabulator";
import TabulatorTableOptions from "../../utils/TabulatorTableOptions";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { renderToStaticMarkup } from "react-dom/server";
import { request } from "axios";
import { useNavigate } from "react-router-dom";

// import withReactContent from "sweetalert2-react-content";

const ManagerSetting = () => {
  const navigateTo = useNavigate();
  const prefixUrl = localStorage.getItem("apiUrl");
  const ReactTabulatorRef = useRef();
  const [isTableReady, setIsTableReady] = useState(false);
  const [needToReloadTable, setNeedToReloadTable] = useState(true);
  const [myTabulator, setMyTabulator] = useState({
    column: [],
    data: [],
  });
  const fieldArray = [];

  useEffect(() => {
    _axios
      .get(localStorage.getItem("apiUrl") + "/userDashboard/?request=table")
      .then((response) => {
        console.log(response.data);
        // response = {
        //   column: [
        //     {title: "مشخصه کاربر", field: "title", headerSort: false, resizable: false},
        //     {title: "عنوان داشبورد مدیریتی", field: "KMO", headerSort: false, resizable: false},
        //     {
        //       title: "ورود به تنظیمات ",
        //       headerSort: false,
        //       resizable: false,
        //       // formatter: "buttonCross",
        //       formatter: function (cell, formatterParams, onRendered) {
        //         //cell - the cell component
        //         //formatterParams - parameters set for the column
        //         //onRendered - function to call when the formatter has been rendered
        //
        //         // return "Mr" + cell.getValue(); //return the contents of the cell;
        //         return ''; //return the contents of the cell;
        //       },
        //       width: 130,
        //       align: "center",
        //       cellClick: function (e, cell) {
        //         cell.getRow().delete();
        //       }
        //     },
        //   ],
        //   data: [
        //     {"title": "مدیر", "KMO": "دور خواهم شد از این خاک غریب"},
        //     {"title": "مدیر", "KMO": "دور خواهم شد از این خاک غریب"},
        //     {"title": "مدیر", "KMO": "دور خواهم شد از این خاک غریب"},
        //   ]
        // }
        let column = response.data.column;
        column.push({
          title: "ورود به تنظیمات ",
          headerSort: false,
          resizable: false,
          // formatter: "buttonCross",
          formatter: function (cell, formatterParams, onRendered) {
            //cell - the cell component
            //formatterParams - parameters set for the column
            //onRendered - function to call when the formatter has been rendered

            // return "Mr" + cell.getValue(); //return the contents of the cell;
            return "تنظیمات"; //return the contents of the cell;
          },
          width: 130,
          align: "center",
          cellClick: function (e, cell) {
            //cell.getRow().delete();
            // console.log(e)
            // console.log(cell)
            navigateTo("/AdminDashboardSettings", {
              state: cell.getData(),
            });
          },
        });
        column.map((v) => {
          if (v.field === "id") {
            v.resizable = false;
            v.visible = false;
          }
        });
        let data = response.data.data;

        setMyTabulator({ column, data });
        setIsTableReady(true);
      })
      .catch((error) => console.log(error));
  }, [needToReloadTable]);

  const deleteDashboard = () => {
    const temp = ReactTabulatorRef.current;
    if (temp.table.getSelectedData().length !== 1) {
      toast.error("لطفا یک داشبورد را انتخاب کنید.");
      return;
    }
    let dashBoardTitle = temp.table.getSelectedData()[0].title;
    let dashBoardId = temp.table.getSelectedData()[0].id;

    Swal.fire({
      title: "حذف داشبورد ",
      text: `آیا از حذف داشبورد کاربر  ${dashBoardTitle}   مطمئنید؟`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
    }).then((result) => {
      if (result.isConfirmed) {
        _axios
          .delete(prefixUrl + "/userDashboard/", {
            data: {
              id: dashBoardId,
              request: "deleteDashboard",
            },
          })
          .then((response) => {
            response.data.status === true
              ? Swal.fire({
                  title: response.data.message,
                  icon: "success",
                  confirmButtonText: "باشه",
                })
              : Swal.fire({
                  title: response.data.message,
                  icon: "error",
                  confirmButtonText: "باشه",
                });
            setNeedToReloadTable((prevState) => !prevState);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    });
  };

  function checkName(titleOfSelectedDashboard) {
    const x = {
      request: "checkDuplicate",
      dashboardName: titleOfSelectedDashboard,
    };

    const temp12 = _axios
      .get(
        prefixUrl +
          "/userDashboard/?request=checkDuplicate&dashboardName=" +
          titleOfSelectedDashboard
      )
      .then((response) => {
        if (response.data.status === false) {
          // Swal.showValidationMessage(`نام داشبورد تکراری است.`);
          return true;
        }
      });
    toast.promise(temp12, {
      pending: "در حال بررسی نام",
      error: "درخواست با مشکل رو به رو شد.",
    });
    // //debugger
    return temp12;
  }

  // const formRef = useRef()
  const addDashboardToTable = () => {
    const temp = _axios
      .get(prefixUrl + "/userDashboard/?request=usersList")
      .then((response) => {
        const data = response.data;
        const htmlString = renderToStaticMarkup(
          <>
            <div
            // ref={formRef}
            // style={{width:"350px"}} className={"bg-success"}
            >
              <div
                className={"d-flex flex-wrap w-100 "}
                style={{ padding: "0 3em" }}
              >
                {data.map((v, i) => (
                  <div
                    className="form-check000 text-end"
                    style={{ width: "50%" }}
                  >
                    <input
                      value={v}
                      className="form-check-input userList"
                      type="checkbox"
                      id={i}
                    />
                    <label className="form-check-label " htmlFor={i}>
                      {v}
                    </label>
                  </div>
                ))}
              </div>

              {/*<select*/}
              {/*  style={{width: '350px'}}*/}
              {/*  id={"selectedUser"}*/}
              {/*  className="swal2-input" defaultValue={"nullSelect"}>*/}
              {/*  <option value={"nullSelect"} disabled={true}>انتخاب کنید</option>*/}
              {/*  {data.map((v, i) => <option key={i} value={v}>{v}</option>)}*/}
              {/*</select>*/}
              <input
                style={{ width: "350px" }}
                type="text"
                id="titleOfSelectedDashboard"
                className="swal2-input"
                placeholder="عنوان داشبورد مدیریتی"
              />
            </div>
          </>
        );
        Swal.fire({
          title: "افزودن  داشبورد",
          html: htmlString,
          confirmButtonText: "افزودن",
          cancelButtonText: "لغو",
          focusConfirm: false,
          showCancelButton: true,
          showCloseButton: true,
          preConfirm: () => {
            const userList = Swal.getPopup().querySelectorAll(".userList");
            const userListArray = [];
            for (const userListArrayElement of userList) {
              if (userListArrayElement.checked) {
                userListArray.push(userListArrayElement.value);
              }
            }

            const titleOfSelectedDashboard = Swal.getPopup().querySelector(
              "#titleOfSelectedDashboard"
            ).value;
            // if (!selectedUser || !titleOfSelectedDashboard || selectedUser==="nullSelect") {
            //   Swal.showValidationMessage(`لطفا  موارد را تکمیل کنید.`)
            // }
            // (userListArray.length===0 || userList === "nullSelect") && Swal.showValidationMessage(`لطفا یک کاربر انتخاب کنید.`);
            !titleOfSelectedDashboard &&
              Swal.showValidationMessage(`لطفا  یک عنوان وارد کنید.`);
            if (titleOfSelectedDashboard.length > 0) {
              // باید برم پرامیس رو بررسی کنم تا همنیجا بهش پیام بدم. اما نیاز به بررسی بیشتر داره
              //status = checkName(titleOfSelectedDashboard);
              //`نام داشبورد تکراری است.`
              return {
                userListArray: userListArray,
                titleOfSelectedDashboard: titleOfSelectedDashboard,
              };
            }
          },
        }).then((result) => {
          const { userListArray, titleOfSelectedDashboard } = result.value;
          const url = localStorage.getItem("apiUrl") + "/userDashboard/";
          const dataToSendBackend = {
            request: "addDashboard",
            data: { userListArray, titleOfSelectedDashboard },
          };
          const addUserRequest = _axios
            .post(url, dataToSendBackend)
            .then((response) => {
              if (response.data.status) {
                toast.success(response.data.message);
                setNeedToReloadTable((prevState) => !prevState);
              } else {
                // Swal.showValidationMessage(response.data.message);
                // addDashboardToTable()
                Swal.fire({
                  title: response.data.message,
                  icon: "error",
                  confirmButtonText: "باشه",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
          toast.promise(addUserRequest, {
            pending: "لطفا صبر کنید...",
            error: "درخواست با مشکل رو به رو شد.",
          });
        });
        //
      })
      .catch((error) => {
        toast.error(error);
      });

    toast.promise(temp, {
      pending: "لطفا صبر کنید...",
      error: "درخواست با مشکل رو به رو شد.",
    });
  };
  const editUserAccessToDashboard = () => {
    const tempTable = ReactTabulatorRef.current;
    if (tempTable.table.getSelectedData().length !== 1) {
      toast.error("لطفا یک کاربر را انتخاب کنید.");
      return;
    }
    let dashBoardTitle = tempTable.table.getSelectedData()[0].title;
    let dashBoardId = tempTable.table.getSelectedData()[0].id;
    const url1 = localStorage.getItem("apiUrl") + "/check_user/?list=";

    const temp = _axios
      .get(
        prefixUrl +
          "/userDashboard/?request=dashboardUsers&dashboardId=" +
          dashBoardId
      )
      .then((response) => {
        let data = response.data;
        //debugger
        const htmlString = renderToStaticMarkup(
          <>
            <div>
              <div
                className={"d-flex flex-wrap w-100 "}
                style={{ padding: "0 3em" }}
              >
                {data.map((v, i) => (
                  <div
                    className="form-check000 text-end"
                    style={{ width: "50%" }}
                  >
                    <input
                      value={v.id}
                      className="form-check-input userList"
                      type="checkbox"
                      id={"" + i}
                      checked={v.checked}
                    />
                    <label className="form-check-label " htmlFor={"" + i}>
                      {v.id}
                    </label>
                  </div>
                ))}
              </div>
              <input
                style={{ width: "350px" }}
                type="text"
                id="titleOfSelectedDashboardInEdit"
                className="swal2-input"
                placeholder="عنوان داشبورد مدیریتی"
                value={dashBoardTitle}
              />
            </div>
          </>
        );
        Swal.fire({
          title: "ویرایش داشبورد",
          html: htmlString,
          confirmButtonText: "ویرایش",
          cancelButtonText: "لغو",
          focusConfirm: false,
          showCancelButton: true,
          showCloseButton: true,
          preConfirm: () => {
            const userList = Swal.getPopup().querySelectorAll(".userList");
            const userListArray = [];
            for (const userListArrayElement of userList) {
              if (userListArrayElement.checked) {
                userListArray.push(userListArrayElement.value);
              }
            }

            const titleOfSelectedDashboardInEdit =
              Swal.getPopup().querySelector(
                "#titleOfSelectedDashboardInEdit"
              ).value;
            // if (!selectedUser || !titleOfSelectedDashboard || selectedUser==="nullSelect") {
            //   Swal.showValidationMessage(`لطفا  موارد را تکمیل کنید.`)
            // }
            // (userListArray.length===0 || userList === "nullSelect") && Swal.showValidationMessage(`لطفا یک کاربر انتخاب کنید.`);
            !titleOfSelectedDashboardInEdit &&
              Swal.showValidationMessage(`لطفا  یک عنوان وارد کنید.`);
            return {
              userListArray: userListArray,
              titleOfSelectedDashboard: titleOfSelectedDashboardInEdit,
            };
          },
        }).then((result) => {
          //debugger
          const { userListArray, titleOfSelectedDashboard } = result.value;
          const url = localStorage.getItem("apiUrl") + "/userDashboard/";
          const dataToSendBackend = {
            id: dashBoardId,
            request: "editDashboard",
            data: { userListArray, titleOfSelectedDashboard },
          };
          const editUserRequest = _axios
            .put(prefixUrl + "/userDashboard/", dataToSendBackend)
            .then((response) => {
              if (response.data.status) {
                toast.success(response.data.message);
                setNeedToReloadTable((prevState) => !prevState);
              } else {
                // Swal.showValidationMessage(response.data.message);
                // addDashboardToTable()
                Swal.fire({
                  title: response.data.message,
                  icon: "error",
                  confirmButtonText: "باشه",
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
          toast.promise(editUserRequest, {
            pending: "لطفا صبر کنید...",
            // success: "کاربر به لیست اضافه شد.",
            error: "درخواست با مشکل رو به رو شد.",
          });
        });
        //
      })
      .catch((error) => {
        toast.error(error);
      });

    toast.promise(temp, {
      pending: "لطفا صبر کنید...",
      error: "درخواست با مشکل رو به رو شد.",
    });
  };
  return isTableReady ? (
    <>
      <>
        <ReactTabulator
          className={"myTable1"}
          ref={ReactTabulatorRef}
          columns={myTabulator.column}
          data={myTabulator.data}
          options={{ selectable: 1, height: "100%" }}
          // events={{ rowClick: rowClickHandler }}
        />
      </>
      <div className={"text-center mt-5"}>
        <Button onClick={addDashboardToTable}> افزودن </Button>

        <Button onClick={editUserAccessToDashboard}> ویرایش </Button>
        <Button onClick={deleteDashboard} color={"redBtn"}>
          {" "}
          حذف{" "}
        </Button>
      </div>
    </>
  ) : (
    <></>
  );
};

export default ManagerSetting;
